import React from "react";

import { CardComponentProps } from "./card.props";
import { card } from "./card.style";
import { CardContextProvider } from "./context/card.context";

const CardBase = <T extends React.ElementType = "div">({
    ref,
    className,
    imgAlignment,
    tag,
    border = true,
    ...attributes
}: CardComponentProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const { base } = card({ border });

    return (
        <CardContextProvider
            border={border}
            imgAlignment={imgAlignment}
        >
            <Tag
                {...attributes}
                className={base({ className })}
                ref={ref}
            />
        </CardContextProvider>
    );
};

export { CardBase };
